import Search from './components/search'
import AppMenu from './components/app-menu'
import MapControls from './components/map-controls'
import MapView from './components/map-view'

export default {
  data() {
    return {
      name: 'app',
      showSearch: false,
      showMenu: false,
      showDrawer: false,
      showSnackbar: false,
      snackbarMessage: undefined
    }
  },
  methods: {
    toggleMenu() {
      if (this.showDrawer) {
        this.showDrawer = false
        if (this.showSearch) {
          setTimeout(() => this.toggleMenu())
        }
      } else {
        this.showSearch = false
        this.showMenu = true
        this.showDrawer = true
      }
    },

    toggleSearch() {
      if (this.showDrawer) {
        this.showDrawer = false
        if (this.showMenu) {
          setTimeout(() => this.toggleSearch())
        }
      } else {
        this.showSearch = true
        this.showMenu = false
        this.showDrawer = true
      }
    },
    hideDrawer() {
      this.showDrawer = false
    },
    shortcutListener(event) {
      const key = event.key

      if (!this.showDrawer) {
        if (key === 'm') {
          this.toggleMenu()
        } else if (key === 's') {
          // need the next line to keep the 's' out of the search input
          event.preventDefault()
          this.toggleSearch()
        }
      } else if (key === 'Escape') {
        this.hideDrawer()
      }
    }
  },
  created() {
    window.addEventListener('keydown', this.shortcutListener)
  },
  components: {
    Search,
    AppMenu,
    MapControls,
    MapView
  }
}
